module.exports = __webpack_public_path__ + "img/logo.57280fd7.png";